import React, { useState } from "react";
import "./Foto.css";
// import imgActivity from "../../assets/image/img-lomba.png";
import imgArrowGallery from "../../assets/image/arrow-one.png";
import DataHelper, {dataFoto} from "../../dataHelper/DataHelper";

const Foto = () => {
  return (
    <>
      <div className='container-img-gallery lg:mt-10 sm:mt-5 grid lg:grid-cols-3 md:grid-cols-3 gap-5'>
        {DataHelper && dataFoto.map((foto, index) => (
          <div key={index} className='card-gallery relative overflow-hidden'>
            {/* <img src={require(`../../assets/image/${foto.img}`)} alt='' srcSet='' /> */}
            <img src={foto.img} alt='' srcSet='' />
            <div className='gallery-box w full'>
              <p className='text-hover'>{foto.desc}</p>
              <p className='text-hover'>{foto.date}</p>
              <img
                src={imgArrowGallery}
                alt=''
                srcset=''
                className='img-hov-arrow'
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Foto;
